import React, { Component } from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import AppContainer from './AppContainer';
import { Provider } from "react-redux";
import { createStore } from "redux";
import reducer from './reducers/index'
import { CookiesProvider } from 'react-cookie';
import withSizes from 'react-sizes'
import {  Cookies } from 'react-cookie';
import { create } from 'jss';
import rtl from 'jss-rtl';
import { StylesProvider, jssPreset } from '@material-ui/core/styles';



import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";

const THEME = createMuiTheme({
   typography: {
    "fontFamily": "\"samim\", \"Helvetica\", \"Arial\", sans-serif",
    "fontSize": 12.5,
    "fontWeightLight": 300,
    "fontWeightRegular": 400,
    "fontWeightMedium": 500,
    'direction': 'rtl',
   }
});
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

class App extends Component{


  cookies=new Cookies();
  store = createStore(reducer)

  constructor() {
      super();
      this.state = {
     };

    }

    componentDidMount() {
    }


  render() {
    return (
      <StylesProvider jss={jss}>
              <CookiesProvider>
                     <MuiThemeProvider theme={THEME}>
                          <Provider store={this.store}>
                              <AppContainer/>
                          </Provider>
                        </MuiThemeProvider>
              </CookiesProvider>
      </StylesProvider>

    );
  }
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
})

export default withSizes(mapSizesToProps)(App)
